import apiClient from "../apiClient";

const resource = "PatientsInvoices";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    getForPrint: id => apiClient.get(`${resource}/${id}/print`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    delete: id => apiClient.delete(`${resource}/${id}`),
    approval: id => apiClient.put(`${resource}/${id}/approval`),
    search: params => apiClient.get(`${resource}/search?${params}`),
    cancel: id => apiClient.put(`${resource}/${id}/cancel`),
    getAppointments: params => apiClient.get(`${resource}/appointments?${params}`),

};
